import { render, staticRenderFns } from "./CropsTable.vue?vue&type=template&id=53d1b2da&"
import script from "./CropsTable.vue?vue&type=script&lang=ts&"
export * from "./CropsTable.vue?vue&type=script&lang=ts&"
import style0 from "./crops-table.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports